import { Exception } from 'src/exceptions/Exception';
export class NotFoundException extends Exception {}
